import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import { formatDate, formatMonth } from '3-foundation/Localization/formatDate';
import logger from '3-foundation/Logging/logger';
interface Props extends Umbraco.BasePage {
	date: string;
	heading: string;
	teaser: { markup: string };
	image: Umbraco.Image[];
	imageAltText?: string;
	documentLink: Umbraco.Image[]; // pdf has same properties as image
}

export const mapDocumentPageProperties = async (
	{ date, heading, teaser, image, imageAltText, documentLink, ...properties }: Props,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.DocumentPageProperties> => {
	try {
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			date: date || null,
			dateDisplay: date ? formatDate({ dateInput: date, locale }) : null,
			dateMonth: date ? formatMonth({ dateInput: date, locale }) : null,
			heading,
			teaser: teaser?.markup,
			image: mapFirstImage(image ?? []),
			imageAltText: imageAltText || null,
			link: documentLink ? { name: documentLink?.[0].name, url: mapFirstImage(documentLink ?? [])?.url } : null,
		};
	} catch (e) {
		logger.error('Could not map DocumentPage Properties', e);
		throw new Error('Could not map DocumentPage Properties', e);
	}
};
